import React from 'react';

import { Link, useHistory } from 'react-router-dom';

import { useDispatch,} from 'react-redux';

import { logout } from '../../actions/auth';

import '../../styles/navTopMenuStyle.scss';

import { validateAccessUser } from '../../constants/component/validateAccessUser';
import * as view from '../../constants/models/viewsList';
import { ADMINISTRADOR, ADMINISTRADOR_ZONA, EMPLEADO, GERENTE, REPRESENTANTE } from '../../constants/models/typeOperationRol';
import { useAuthInfo } from '../../utils/authUtils';

export const hasAccess = (user,...views) => {
  return views.some(view => validateAccessUser(view, user))

};
export const displayContent = (hasAccess, ...conditions) =>{
  if(conditions.length === 0){
    return hasAccess ? 'd-inline' : 'd-none';
  }
  return hasAccess && conditions.every(condition => condition) ? 'd-inline' : 'd-none';
}

export const NavTopMenu = () => {

  const dispatch = useDispatch();

  const history = useHistory();

  const {operationRol, userLogged: user, isLoggedIn} = useAuthInfo();
  const userOperationalRol = user.operationRol === GERENTE ? REPRESENTANTE : user.operationRol
  const userRole = isLoggedIn ? userOperationalRol : '---';

  /**
     * Realiza el cierre de sesión y redirección a login
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
  const handleLogout = () => {
    dispatch( logout() )
    .then(()=>{
      console.log('ok logout')
      history.push('/auth/');
      }
    );
  }
    return (
        <nav className="navbar navbar-expand-sm base-container mt-0 me-0 mb-3">
          <div className="container-fluid p-0">
            <div className="row m-0 p-0 w-100">
              <div className="col-12">
                <div className="d-flex flex-row-reverse">
                <button className="navbar-toggler btn btn-expand-menu" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
                  <i className="fas fa-bars"></i>
                </button>
                  <div className="">
                    <div className="btn-group dropstart">
                      <button className="btn custom-btn-icons" href="/#" type="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="fas fa-cog"></i>
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <li><button type="button" className="btn custom-btn-icons" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt"></i><span>Cerrar sesión</span>
                    </button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="spacerClientName">
                    <span className="d-block h6 m-0 p-0">{isLoggedIn ? user.name:'---'}</span>
                    <span className="d-block client-number ps-3">Usuario: {isLoggedIn ? user.noCustomer :'---'} | Rol: {userRole}</span>
                  </div>

                </div>
              </div>
              <div className="collapse d-sm-none" id="navbarToggleExternalContent">
                <ul className="nav nav-pills flex-column w-100 mb-sm-auto ps-3 mb-0 align-items-center align-items-sm-start" id="menu">
                    <li className="nav-item w-100 pt-2 ps-3 pb-3 action-link-menu">
                    <Link to='/' className="h6 px-0 custom-text-menu align-middle">
                    <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-home"></i>
                          <span className="ms-1">Inicio</span>
                      </Link>
                    </li>
                    <span className={`
                      ${displayContent(hasAccess(user,view.VIEW_ZONE_ADMIN, view.VIEW_GROUP, view.CREATE_GROUP, view.VIEW_USER, view.UPDATE_USER, view.CREATE_CONTENT, view.VIEW_CONTENT))}
                      h5 custom-text-title-menu
                    `}>Administración</span>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_ZONE_ADMIN),operationRol === ADMINISTRADOR_ZONA)}
                      nav-item w-100 ps-3 pt-2 pb-2 action-link-menu
                    `}>
                        <a href="#submenu1" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-user-friends"></i>
                          <span className="ms-1">Administrador de zona</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenu1" data-bs-parent="#menu">
                          <li className={`
                            ${displayContent(hasAccess(user,view.VIEW_ZONE_ADMIN),operationRol === ADMINISTRADOR_ZONA)}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/administration/admin-zone' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Ver administrador</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_GROUP,view.CREATE_GROUP),operationRol !== EMPLEADO, operationRol !== ADMINISTRADOR_ZONA)}
                      nav-item w-100 ps-3 pt-2 pb-2 action-link-menu
                    `}>
                        <a href="#submenu2" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-user-friends"></i>
                          <span className="ms-1">Grupos</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenu2" data-bs-parent="#menu">
                          <li className={`
                            ${displayContent(hasAccess(user,view.VIEW_GROUP) ,operationRol !== EMPLEADO)}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/administration/groups' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Ver grupos</span>
                            </Link>
                          </li>
                          <li className={`
                            ${displayContent(hasAccess(user,view.CREATE_GROUP),operationRol === ADMINISTRADOR)}
                            w-100 action-link-menu pt-2
                          `}>
                            <Link to='/administration/groups/create' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Nuevo grupo</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_USER ,view.UPDATE_USER),operationRol !== EMPLEADO,operationRol !== ADMINISTRADOR_ZONA)}
                      nav-item w-100 ps-3 pt-2 pb-2 action-link-menu
                    `}>
                        <a href="#submenu3" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-users"></i>
                          <span className="ms-1">Representantes</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenu3" data-bs-parent="#menu">
                          <li className="w-100 action-link-menu pb-3 pt-2">
                            <Link to='/administration/users' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Ver representantes</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.CREATE_CONTENT,view.VIEW_CONTENT))}
                      nav-item w-100 pt-2 ps-3 pb-2 action-link-menu
                    `}>
                        <a href="#submenuContent" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="far fa-newspaper"></i>
                          <span className="ms-1">Contenidos</span>
                          <i className="fas fa-angle-down mt-1 ms-auto"></i>
                        </a>
                        <ul className="collapse nav flex-column pb-2 ms-2" id="submenuContent" data-bs-parent="#menu">
                          <li className="w-100 action-link-menu pb-3 pt-2 ">
                            <Link to='/administration/content/marketing' className="px-1 custom-text-menu text-sub-menu">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Avisos</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                   
                    <span className={`
                      ${ displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM,view.VIEW_PREVIOUS_PROGRAM_DETAIL,view.VIEW_PAYMENT,view.VIEW_PAYMENT_DETAIL,view.VIEW_ADVANCE_PAYMENT,view.VIEW_SALE_ORDER))}
                      custom-text-title-menu h5
                    `}>Operación</span>

                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM ,view.VIEW_PREVIOUS_PROGRAM_DETAIL))}
                      nav-item w-100 pt-2 ps-3 pb-2 action-link-menu
                    `}>
                      <a href="#submenuPreviousProgram" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-boxes"></i>
                        <span className="ms-1">Programa previo</span>
                        <i className="fas fa-angle-down mt-1 ms-auto"></i>
                      </a>
                      <ul className="collapse nav flex-column ms-2 pb-2" id="submenuPreviousProgram" data-bs-parent="#menu">
                        <li className={`
                          ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM))}
                          w-100 action-link-menu pb-3 pt-2
                        `}>
                          <Link to='/operation/previous-program' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-inline">Ver programa previo</span>
                          </Link>
                        </li>
                        <li className={`
                          ${displayContent(hasAccess(user,view.VIEW_PREVIOUS_PROGRAM_DETAIL))}
                          w-100 action-link-menu pt-2
                        `}>
                          <Link to='/operation/detail-previous-program' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-inline">Detalle del programa previo</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_PAYMENT,view.VIEW_PAYMENT_DETAIL ,view.VIEW_ADVANCE_PAYMENT))}
                      nav-item w-100 pb-2 pt-2 ps-3 action-link-menu
                    `}>
                        <a href="#submenuPayment" data-bs-toggle="collapse" className="custom-text-menu h6 w-100 px-0 d-flex pe-3">
                          <i className="fas fa-angle-right hide-icon"></i>
                          <i className="fas fa-credit-card"></i>
                          <span className="ms-1">Pagos</span>
                          <i className="fas fa-angle-down ms-auto mt-1"></i>
                        </a>
                        <ul className="collapse nav flex-column ms-2 pb-2" id="submenuPayment" data-bs-parent="#menu">
                        <li className={`${ displayContent(hasAccess(user,view.VIEW_ADVANCE_PAYMENT),operationRol !== ADMINISTRADOR_ZONA) } w-100 action-link-menu pb-3 pt-2 `}>
                            <Link to='/operation/advance-payment' className="px-1 custom-text-menu text-sub-menu">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Referencia de anticipo</span>
                            </Link>
                          </li>
                          <li className={`
                            ${displayContent(hasAccess(user,view.VIEW_PAYMENT))}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/payment' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Pago de facturas</span>
                            </Link>
                          </li>
                          <li className={`
                            ${displayContent(hasAccess(user,view.VIEW_PAYMENT_DETAIL))}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/detail-payment' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Pagos procesados</span>
                            </Link>
                          </li>
                          <li className={`
                            ${displayContent(hasAccess(user,view.VIEW_ANTICIPATION_PAYMENT))}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/detail-advance-payment' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Pagos de anticipo</span>
                            </Link>
                          </li>
                          <li className={`
                            ${displayContent(hasAccess(user,view.BILLING_STATEMENT))}
                            w-100 action-link-menu pb-3 pt-2
                          `}>
                            <Link to='/operation/billing-statement' className="custom-text-menu text-sub-menu px-1">
                              <i className="fas fa-angle-right hide-icon"></i>
                              <span className="d-inline">Estados de cuenta</span>
                            </Link>
                          </li>
                        </ul>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_SALE_ORDER))}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/sale-order' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-coins"></i>
                        <span className="ms-1">Órdenes de venta</span>
                      </Link>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_DISCOUNT_AND_INVOINCE))}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/discounts-and-invoices/header' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-tags"></i>
                        <span className="ms-1">Bonificaciones y Descuentos</span>
                      </Link>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_MANAGEMENT_ADVANCES_INVOICES))}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/advance-and-invoices' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fa fa-table"></i>
                        <span className="ms-1">Consulta de anticipos</span>
                      </Link>
                    </li>
                    <li className={`
                      ${displayContent(hasAccess(user,view.VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS))}
                      nav-item w-100 pt-2 ps-3 pb-3 action-link-menu
                    `}>
                      <Link to='/operation/advances-invoices-and-complements' className="h6 custom-text-menu px-0 align-middle">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fa fa-table"></i>
                        <span className="ms-1">Consulta de facturas</span>
                      </Link>
                    </li>
                                      {/* <li className={`
                                      ${displayContent(hasAccess(user,view.VIEW_ADVANCES_INVOICES_AND_COMPLEMENTS))}
                                      nav-item w-100 pt-2 pb-2 ps-3 action-link-menu
                                      `}>
                                        <Link to='/operation/advances-invoices-reference-detail' className="custom-text-menu h6 px-0 align-middle">
                                            <i className="fas fa-angle-right hide-icon"></i>
                                            <i className="fa fa-table"></i>
                                            <span className="ms-1">Consulta de referencias</span>
                                        </Link>
                                      </li> */}
                    <span className={`
                      ${displayContent(hasAccess(user,view.UPDATE_PASS))}
                      custom-text-title-menu h5
                    `}>Configuración</span>
                    <li className={`
                      ${displayContent(hasAccess(user,view.UPDATE_PASS))}
                      nav-item w-100 pt-2 ps-3 pb-2 action-link-menu
                    `}>
                      <a href="#submenuAccount" data-bs-toggle="collapse" className="custom-text-menu h6 px-0 w-100 d-flex pe-3">
                        <i className="fas fa-angle-right hide-icon"></i>
                        <i className="fas fa-user"></i>
                        <span className="ms-1">Cuenta</span>
                        <i className="fas fa-angle-down mt-1 ms-auto"></i>
                      </a>
                      <ul className="collapse nav flex-column ms-2 pb-2" id="submenuAccount" data-bs-parent="#menu">
                        <li className={`
                          ${displayContent(hasAccess(user,view.UPDATE_PASS))}
                          w-100 action-link-menu pb-3 pt-2
                        `}>
                          <Link to='/configuration/account' className="custom-text-menu text-sub-menu px-1">
                            <i className="fas fa-angle-right hide-icon"></i>
                            <span className="d-inline">Cambiar contraseña</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
    )
}